export enum FILE_ACTION {
    Import = 'import',
    ExportSave = 'exportSave',
    ExportSubmit = 'exportSubmit',
    Calculate = 'calculate',
    Optimize = 'optimize',
    Parse = 'parse',
    Links = 'links',
    History = 'History',
    SendQuestionnaire = 'SendQuestionnaire',
    SendQuestionnaireOwner = 'SendQuestionnaireOwner',
    SendQuestionnaireOther = 'SendQuestionnaireOther',
    CreateQuestionnaire = 'CreateQuestionnaire',
    SendResult = 'sendResult',
    Followers = 'followers',
}

export function getLocalizedImportCategory() {
    return $localize`:@@declarations.actionCategories.import:Importeer`;
}
export function getLocalizedExportCategory() {
    return $localize`:@@declarations.actionCategories.export:Exporteer`;
}

export function getLocalizedQuestionnaireCategory() {
    return $localize`:@@declarations.actionCategories.questionnaire:Vragenlijst`;
}

export type FILE_ACTION_UTIL = {
    name: string;
    detailName: string;
    action: FILE_ACTION;
    isManagerAction: boolean;
    category: string | undefined;
};

export function getFileActionImport(): FILE_ACTION_UTIL {
    return {
        name: $localize`:@@declarations.importTOW:Importeer uit tax-on-web`,
        detailName: $localize`:@@declarations.importTOW.detail:Sync met TOW/MMF`,
        action: FILE_ACTION.Import,
        isManagerAction: true,
        category: getLocalizedImportCategory(),
    };
}

export function getFileActionExportSave(): FILE_ACTION_UTIL {
    return {
        name: $localize`:@@declarations.exportSave:Om op te slaan`,
        detailName: $localize`:@@declarations.exportSave.detail:Bewaar in TOW`,
        action: FILE_ACTION.ExportSave,
        isManagerAction: false,
        category: getLocalizedExportCategory(),
    };
}

export function getFileActionExportSubmit(): FILE_ACTION_UTIL {
    return {
        name: $localize`:@@declarations.exportSubmit:Om in te dienen`,
        detailName: $localize`:@@declarations.exportSubmit.detail:Dien in bij TOW`,
        action: FILE_ACTION.ExportSubmit,
        isManagerAction: false,
        category: getLocalizedExportCategory(),
    };
}

export function getFileActionCreateQuestionnaire(): FILE_ACTION_UTIL {
    return {
        name: $localize`:@@declarations.createQuestionnaire:Maak vragenlijst aan`,
        detailName: $localize`:@@declarations.createQuestionnaire:Maak vragenlijst aan`,
        action: FILE_ACTION.CreateQuestionnaire,
        isManagerAction: true,
        category: getLocalizedQuestionnaireCategory(),
    };
}

export function getFileActionSendQuestionnaire(): FILE_ACTION_UTIL {
    return {
        name: $localize`:@@declarations.sendQuestionnaire:Verzend vragenlijst`,
        detailName: $localize`:@@declarations.sendQuestionnaire:Verzend vragenlijst`,
        action: FILE_ACTION.SendQuestionnaire,
        isManagerAction: true,
        category: getLocalizedQuestionnaireCategory(),
    };
}

export function getFileActionSendResult(): FILE_ACTION_UTIL {
    return {
        name: $localize`:@@declarations.sendResult:Verzend resultaat`,
        detailName: $localize`:@@declarations.sendResult:Verzend resultaat`,
        action: FILE_ACTION.SendResult,
        isManagerAction: true,
        category: undefined,
    };
}

export function getFileActionCalculate(): FILE_ACTION_UTIL {
    return {
        name: $localize`:@@declarations.calculate:Bereken`,
        detailName: $localize`:@@declarations.calculate:Bereken`,
        action: FILE_ACTION.Calculate,
        isManagerAction: false,
        category: undefined,
    };
}

export function getFileActionOptimize(): FILE_ACTION_UTIL {
    return {
        name: $localize`:@@declarations.optimize:Optimaliseer`,
        detailName: $localize`:@@declarations.optimize:Optimaliseer`,
        action: FILE_ACTION.Optimize,
        isManagerAction: true,
        category: undefined,
    };
}

export function getFileActionParse(): FILE_ACTION_UTIL {
    return {
        name: $localize`:@@declarations.parse:Importeer vanuit bestand`,
        detailName: $localize`:@@declarations.parse.pdf:Importeer PDF`,
        action: FILE_ACTION.Parse,
        isManagerAction: true,
        category: getLocalizedImportCategory(),
    };
}

export function getFileActionLinks(): FILE_ACTION_UTIL {
    return {
        name: $localize`:@@declarations.links:Gelinkte dossiers`,
        detailName: $localize`:@@declarations.links.detail:Link emz./venn.`,
        action: FILE_ACTION.Links,
        isManagerAction: true,
        category: undefined,
    };
}

export function getFileActionHistory(): FILE_ACTION_UTIL {
    return {
        name: $localize`:@@declarations.history:Geschiedenis`,
        detailName: $localize`:@@declarations.history:Geschiedenis`,
        action: FILE_ACTION.History,
        isManagerAction: true,
        category: undefined,
    };
}

export function getFileActionFollowers(): FILE_ACTION_UTIL {
    return {
        name: $localize`:@@declarations.followers:Volgers`,
        detailName: $localize`:@@declarations.followers:Volgers`,
        action: FILE_ACTION.Followers,
        isManagerAction: true,
        category: undefined,
    };
}

export function getDefaultActions(): FILE_ACTION_UTIL[] {
    return [
        getFileActionLinks(),
        getFileActionImport(),
        getFileActionParse(),
        getFileActionCreateQuestionnaire(),
        getFileActionSendQuestionnaire(),
        getFileActionCalculate(),
        getFileActionOptimize(),
        getFileActionSendResult(),
        getFileActionExportSave(),
        getFileActionExportSubmit(),
        getFileActionHistory(),
        getFileActionFollowers(),
    ];
}
